var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/ic-chevron-down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/ic-chevron-down",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-down-outline",
    transform: "translate(6.000000, 9.000000)",
    stroke: "#243758",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0 0 6 6 12 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronDown);
export default __webpack_public_path__ + "static/media/ic-chevron-down.3069f5db4f5b1366becf3b42dd2ceb65.svg";
export { ForwardRef as ReactComponent };